module.exports = __webpack_public_path__ + "static/img/innerbanner.fe7fe81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/images/innerbanner.jpg
// module id = J9+H
// module chunks = 2